import React, { useState, useEffect, useContext } from 'react'
import { Button, FormControl, Modal, Typography, TextField } from '@material-ui/core';
import { CustomerAccountContext } from '../contexts/customer-account-context'

const modalStyles = { 
    backgroundColor: 'white', 
    height: 225, 
    width: 400, 
    position: "fixed", 
    top: "50%", 
    left: "50%", 
    transform: "translate(-50%, -50%)",
    padding: "2rem"
}

export const CustomerEditDetails = ({ isOpen, onClose, updateAccountName }) => {
    const [ newAccountName, setNewAccountName ] = useState('')
    const [ hasErrors, setHasErrors ] = useState(false)
    const customerContext = useContext(CustomerAccountContext)

    useEffect(() => {
        setNewAccountName(customerContext.account.name)
    }, [])

    const handleOnSubmit = async (e) => {
        e.preventDefault()
        await updateAccountName(newAccountName)
        await customerContext.refreshCustomer()
        onClose()
    }

    const handleOnChange = (e) => {
        const newName = e.target.value

        if (!newName.trim()) {
            setHasErrors(true)
        } else {
            setHasErrors(false)
        }

        setNewAccountName(newName)
    }

    const handleOnClose = () => {
        setNewAccountName(customerContext.account.name)
        setHasErrors(false)
        onClose()
    }

    return (
        <Modal open={isOpen} onClose={handleOnClose}>
            <div style={modalStyles}>
                <Typography variant="h5" color="primary">Edit Account Details</Typography>
                <form onSubmit={handleOnSubmit}>
                    <FormControl fullWidth>
                        <div style={{ margin: "2rem 0" }}>
                            <TextField
                                error={hasErrors}
                                required
                                fullWidth
                                label="New Account Name"
                                value={newAccountName}
                                helperText={ hasErrors ? "Account Name is required" : undefined }
                                onChange={handleOnChange}
                            />
                        </div>
                        <div style={{display: "flex", justifyContent: "flex-end", width: "100%"}}>
                            <Button
                                color="primary"
                                disableElevation
                                onClick={handleOnClose}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit" 
                                variant="contained"
                                color="primary"
                                disableElevation
                                disabled={hasErrors}
                            >
                                Update
                            </Button>
                        </div>
                    </FormControl>
                </form>
            </div>
        </Modal>
    )
}
